var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cart-modal-wrapper",
      on: { mouseenter: _vm.openModal, mouseleave: _vm.closeModal }
    },
    [
      _vm._t("default"),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.cartModalOpen
          ? _c(
              "div",
              {
                staticClass: "cart-modal tooltip popover vue-popover-theme",
                attrs: { tabindex: "0", "x-placement": "bottom" }
              },
              [
                _c("div", { staticClass: "wrapper" }, [
                  _c(
                    "div",
                    {
                      staticClass: "tooltip-inner popover-inner",
                      staticStyle: { position: "relative" }
                    },
                    [
                      _c("cart-modal-content", {
                        on: { "open-full": _vm.openSidecart }
                      })
                    ],
                    1
                  ),
                  _c("div", {
                    staticClass: "tooltip-arrow popover-arrow",
                    style: _vm.arrowStyle
                  })
                ])
              ]
            )
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }